/**
 * GroupTile — 88px group thumbnail used in the My Groups carousel.
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { Group } from '@wlb/shared/types/groups';
import { GroupsTabIcon } from '../../components/ui/icons';
import { GroupImage } from './GroupImage';
import { resolveGroupImageUrl } from './groupMedia';
import './groups.css';

interface GroupTileProps {
  group: Group;
  onSelect: (group: Group) => void;
}

export function GroupTile({ group, onSelect }: GroupTileProps) {
  const { t } = useTranslation();
  const imageUrl = resolveGroupImageUrl(group.groupImage);

  return (
    <button
      type="button"
      className="group-tile"
      onClick={() => onSelect(group)}
      aria-label={t('home.groups.accessibility.openGroup', { name: group.groupName })}
    >
      <GroupImage
        src={imageUrl}
        imageClassName="group-tile__image"
        fallbackClassName="group-tile__placeholder"
        fallback={<GroupsTabIcon size={32} />}
      />
      <span className="group-tile__name">{group.groupName}</span>
    </button>
  );
}
